import { formatLongDate, parseCalendarDate } from '../../../../utils/dateFormatter';

export const formatCurrency = (value) => {
  const numericValue = Number(value || 0);
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    maximumFractionDigits: 0
  }).format(numericValue);
};

export const formatDate = (value) => {
  if (!parseCalendarDate(value)) {
    const fallback = new Date();
    fallback.setMonth(fallback.getMonth() + 1);
    return formatLongDate(fallback);
  }

  return formatLongDate(value);
};

export const formatTna = (rate) => `${(Number(rate || 0) * 100).toFixed(2)}%`;

export const formatInstallmentPlan = (term, monthlyPayment) => {
  const installmentCount = Number(term || 0);
  return `${installmentCount} cuotas de ${formatCurrency(monthlyPayment)}`;
};
